import React, { useMemo } from "react";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";
import Expander from "../../../../../components/Expander";
import { ACMG_PATHOGENICITY_COLORS } from "../../../../../common/helpers/Constant";

export const getDiseasesTable = (items) => {
  const fixedItems = useMemo(() => {
    const pathogenicityScale = {
      pathogenic: 0,
      "likely pathogenic": 1,
      uncertain: 2,
      "uncertain significance": 3,
      "likely benign": 4,
      benign: 5,
      activating: 6,
    };
    return items
      .map((item) => {
        const tags = (item.tags || []).sort(
          (a, b) => pathogenicityScale[a] - pathogenicityScale[b]
        );
        const sortVal = tags.map((tag) => pathogenicityScale[tag]);
        const minSortVal = Math.min(...sortVal);
        return {
          ...item,
          tags,
          sortVal,
          minSortVal,
        };
      })
      .sort(
        (a, b) =>
          a.minSortVal - b.minSortVal || a.disease.localeCompare(b.disease)
      );
  }, [items]);

  if (Array.isArray(items) && items.length !== 0) {
    const colors = ACMG_PATHOGENICITY_COLORS;
    const result = (
      <table className="varsome-table">
        <thead>
          <tr>
            <th width="5%">Disease</th>
            <th width="12%">Tags</th>
            <th width="8%">Publications</th>
          </tr>
        </thead>
        <Expander showMore="5" component="tbody">
          {fixedItems.map((item, i) => (
            <tr key={`disease-${i}`}>
              <td className="tw-text-left tw-p-2.5" width="25%">
                {item.disease ? item.disease : "-"}
              </td>
              <td className="tw-text-left tw-p-2.5" width="25%">
                {Array.isArray(item.tags) ? (
                  <>
                    {item.tags.map((tag, z) => (
                      <div
                        className="tw-px-1 tw-py-px tw-rounded tw-leading-relaxed tw-inline-block tw-text-2xs tw-font-bold tw-text-white tw-m-1 tw-bg-blue-300"
                        style={{
                          backgroundColor: colors[tag.toLowerCase()],
                        }}
                        key={`tag-${z}`}
                      >
                        {tag}
                      </div>
                    ))}
                  </>
                ) : (
                  "-"
                )}
              </td>
              <td className="tw-text-left tw-p-2.5" width="45%">
                {item.pub_med_references ? (
                  <PublicationLinks limit={10} ids={item.pub_med_references} />
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
